"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.buildQuery=function(e){var o=[];for(var r in e)void 0!==e[r]&&null!==e[r]&&o.push(r+"="+encodeURIComponent(e[r]));return o.join("&")};
